import React from 'react'
import { cn } from './cn'

// Tailwind replacement for CoreUI's <CInput>/<CInputGroup>/
// <CInputGroupPrepend>/<CInputGroupAppend>. InputGroup is a bordered,
// rounded flex row; Input/Prepend/Append are borderless inside it so the
// group reads as one control instead of three stacked boxes.
export const Input = React.forwardRef(({ className, ...props }, ref) => (
  <input
    ref={ref}
    className={cn(
      'tw-min-w-0 tw-flex-1 tw-border-0 tw-bg-transparent tw-px-3 tw-py-1.5',
      'tw-text-sm tw-text-gray-900 placeholder:tw-text-gray-400',
      'focus:tw-outline-none',
      className
    )}
    {...props}
  />
))
Input.displayName = 'Input'

export const InputGroup = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'tw-flex tw-items-stretch tw-rounded tw-border tw-border-gray-300 tw-bg-white',
      'focus-within:tw-border-blue-500',
      className
    )}
    {...props}
  />
))
InputGroup.displayName = 'InputGroup'

export const InputGroupPrepend = ({ className, ...props }) => (
  <div
    className={cn(
      'tw-flex tw-items-center tw-border-r tw-border-gray-300 tw-px-2',
      className
    )}
    {...props}
  />
)

export const InputGroupAppend = ({ className, ...props }) => (
  <div
    className={cn(
      'tw-flex tw-items-center tw-border-l tw-border-gray-300',
      className
    )}
    {...props}
  />
)
